module.exports = __webpack_public_path__ + "static/img/rou_lei_dan_bai_.04e9d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rou_lei_dan_bai_.png
// module id = Y8Zb
// module chunks = 18